

import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class IBSpinner extends Vue {

	@Prop({ type: Number, default: 0 })
	readonly fillPercent!: number

	@Prop({ type: Number, default: 2 })
	readonly width!: number

	@Prop({ type: Number, default: 44 })
	readonly size!: number

	@Prop({ type: String, default: '#0265F0' })
	readonly color!: string

	fillMax: number = 127

	get boxSize(): number {
		return (this.width * 2) + this.size;
	}

	get fillValue(): number {
		return this.fillMax - ((this.fillPercent * this.fillMax) / 100);
	}

}

